(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["paket-secenekleri"] && !Shopify.designMode) return;
  try {
    /*
    Tasarım notu: Temanın "Sepete ekle" butonlarına tıklamayı KESMİYORUZ.
    Bunun yerine ürün formundaki gizli variant id alanını seçili pakete göre
    güncelliyoruz. Böylece temanın kendi akışı (ana buton, sticky bar, hızlı
    satın al) hiç bozulmadan doğru ürünü sepete ekliyor.
  */
  class BundlePicker extends HTMLElement {
    connectedCallback() {
      this.submitBtn = this.querySelector('[data-bp-submit]');
      this.submitText = this.querySelector('[data-bp-submit-text]');
      this.errorEl = this.querySelector('[data-bp-error]');
      this.baseLabel = this.submitText ? this.submitText.textContent.trim() : 'Sepete Ekle';
      this.allowDeselect = this.dataset.allowDeselect === 'true';

      this.addEventListener('change', (e) => {
        if (e.target.matches('input[type="radio"]')) this.sync();
      });

      if (this.allowDeselect) this.enableDeselect();

      if (this.submitBtn) {
        this.submitBtn.addEventListener('click', () => this.addToCart());
      }

      this.captureOriginalVariant();
      this.sync();
    }

    /* ---- Seçim ---- */

    get selectedCard() {
      const input = this.querySelector('input[type="radio"]:checked');
      return input ? input.closest('.bundle-card') : null;
    }

    get isBundleSelected() {
      const card = this.selectedCard;
      return !!card && card.dataset.single !== 'true';
    }

    // "1 Adet" kartı yokken, seçili karta tekrar tıklayınca seçim kalksın
    enableDeselect() {
      this.addEventListener('mousedown', (e) => {
        const label = e.target.closest('.bundle-card');
        if (!label) return;
        const input = label.querySelector('input[type="radio"]');
        label._bpWasChecked = !!(input && input.checked);
      });

      this.addEventListener('click', (e) => {
        const label = e.target.closest('.bundle-card');
        if (!label || !label._bpWasChecked) return;
        const input = label.querySelector('input[type="radio"]');
        if (!input) return;
        e.preventDefault();
        input.checked = false;
        label._bpWasChecked = false;
        this.sync();
      });
    }

    /* ---- Tema formuyla eşitleme ---- */

    static idInputs() {
      return [...document.querySelectorAll('form[action*="/cart/add"] input[name="id"], .shopify-product-form input[name="id"]')];
    }

    captureOriginalVariant() {
      BundlePicker.idInputs().forEach((input) => {
        if (input.dataset.bpOriginalId === undefined) input.dataset.bpOriginalId = input.value;
      });
    }

    syncForm() {
      const card = this.selectedCard;
      const bundleId = card && card.dataset.single !== 'true' ? card.dataset.variantId : null;

      BundlePicker.idInputs().forEach((input) => {
        if (input.dataset.bpOriginalId === undefined) input.dataset.bpOriginalId = input.value;
        const next = bundleId || input.dataset.bpOriginalId;
        if (input.value !== next) {
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    /* ---- Buton etiketleri (yalnızca ekleme, mevcut içeriğe dokunulmaz) ---- */

    syncLabels() {
      const card = this.selectedCard;
      const price = card && card.dataset.single !== 'true' ? card.dataset.priceLabel : null;

      document.querySelectorAll('.add-to-cart-text__content').forEach((host) => {
        if (host.closest('bundle-picker')) return;
        let tag = host.querySelector('.bp-atc-price');
        if (!price) {
          if (tag) tag.remove();
          return;
        }
        if (!tag) {
          tag = document.createElement('span');
          tag.className = 'bp-atc-price';
          host.appendChild(tag);
        }
        tag.textContent = ' · ' + price;
      });
    }

    sync() {
      const card = this.selectedCard;

      if (this.submitBtn) {
        if (card) {
          this.submitBtn.hidden = false;
          const price = card.dataset.priceLabel || '';
          this.submitText.textContent = price ? this.baseLabel + ' · ' + price : this.baseLabel;
        } else {
          this.submitBtn.hidden = true;
        }
      }

      try { this.syncForm(); } catch (e) { /* form bulunamazsa akış bozulmasın */ }
      try { this.syncLabels(); } catch (e) { /* etiket güncellenemezse akış bozulmasın */ }
    }

    /* ---- Blok kendi butonu ---- */

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.hidden = false;
    }

    async addToCart(quantity = 1) {
      const card = this.selectedCard;
      if (!card) return;

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const base = root.replace(/\/$/, '');

      if (this.errorEl) this.errorEl.hidden = true;
      if (this.submitBtn) {
        this.submitBtn.setAttribute('aria-busy', 'true');
        this.submitBtn.disabled = true;
      }

      try {
        const res = await fetch(base + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({ items: [{ id: Number(card.dataset.variantId), quantity: quantity }] }),
        });

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'Ürün sepete eklenemedi.');
        }

        this.afterAdd(base);
      } catch (err) {
        this.showError(err.message || 'Bir hata oluştu, lütfen tekrar deneyin.');
      } finally {
        if (this.submitBtn) {
          this.submitBtn.removeAttribute('aria-busy');
          this.submitBtn.disabled = false;
        }
      }
    }

    afterAdd(base) {
      const behavior = this.dataset.cartBehavior || 'drawer';

      if (behavior === 'cart_page') { window.location.href = base + '/cart'; return; }
      if (behavior === 'checkout') { window.location.href = base + '/checkout'; return; }

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: { source: 'product-form-component', data: { didError: false, source: 'product-form-component' } },
        })
      );

      const drawer = document.querySelector('cart-drawer-component');
      let opened = false;

      if (drawer) {
        for (const method of ['open', 'show', 'showDialog', 'openDrawer']) {
          if (typeof drawer[method] === 'function') {
            try { drawer[method](); opened = true; break; } catch (e) { /* devam */ }
          }
        }
        if (!opened) {
          const dialog = drawer.querySelector('dialog');
          if (dialog && typeof dialog.showModal === 'function') {
            try { dialog.showModal(); opened = true; } catch (e) { /* devam */ }
          }
        }
      }

      if (!opened) {
        const trigger = document.querySelector('cart-icon') || document.querySelector('a[href$="/cart"]');
        if (trigger) { trigger.click(); opened = true; }
      }

      if (!opened) window.location.href = base + '/cart';
    }
  }

  if (!customElements.get('bundle-picker')) {
    customElements.define('bundle-picker', BundlePicker);
  }
  } catch(e) { console.error(e); }
})();

})();
